<template>
    <section class="content" style="background-color: #EBECF1">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-info">
                    <div class="box-header">
                        <h3 class="fuente box-title p-t-10">MANTENIMIENTO DE EX-TRABAJADORES</h3>
                    </div>
                    <div class="box-body">
                        <form role="form">
                            <div class="row">
                                <div class="fuente col-xs-12 table-responsive">
                                    <div class="box-body">
                                        <table aria-describedby="tablaDetalle_info" role="grid" id="tablaDetalle"
                                            class="fuente fs-12 table table-bordered table-striped dataTable">
                                            <thead>
                                                <tr role="row">
                                                    <th aria-label="ITEM" aria-sort="ascending" aria-controls="tablaDetalle"
                                                        tabindex="0" class="sorting_asc table-center-header">ITEM</th>
                                                    <th aria-label="DNI" aria-controls="tablaDetalle" tabindex="0"
                                                        class="sorting">DNI</th>
                                                    <th aria-label="NOMBRE COMPLETO" aria-controls="tablaDetalle"
                                                        tabindex="0" class="sorting">NOMBRE</th>
                                                    <th aria-label="CORREO" aria-controls="tablaDetalle" tabindex="0"
                                                        class="sorting">CORREO</th>
                                                    <th aria-label="CARGO ANTERIOR" aria-controls="tablaDetalle"
                                                        tabindex="0" class="sorting">CARGO ANTERIOR</th>
                                                    <th aria-label="REINCORPORAR" aria-controls="tablaDetalle" tabindex="0"
                                                        class="sorting table-center-header">
                                                        REINCORPORAR
                                                    </th>
                                                    <th aria-label="PENSIONAR" aria-controls="tablaDetalle" tabindex="0"
                                                        class="sorting table-center-header">
                                                        PENSIONAR
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="even" role="row" v-for="(item, index) in extrabs" :key="index">
                                                    <td class="sorting_1 table-center-header">{{ index + 1 }}</td>
                                                    <td>{{ item.dni }}</td>
                                                    <td>{{ item.nombres }} {{ item.apePaterno }} {{ item.apeMaterno }}</td>
                                                    <td>{{ item.correo }}</td>
                                                    <td>{{ item.cargo }}</td>
                                                    <td class="table-center-header">
                                                        <span style="cursor:pointer" class="badge bg-blue"
                                                            data-toggle="modal" @click="verReincorporar(item)"
                                                            data-target="#modalReincoporar">
                                                            <i class="fa fa-undo" aria-hidden="true"></i>
                                                        </span>
                                                    </td>
                                                    <td class="table-center-header">
                                                        <span style="cursor:pointer" class="badge bg-grey"
                                                            data-toggle="modal" @click="verPensionar(item)"
                                                            data-target="#modalPensionar">
                                                            P
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="fuente col-md-12" style="color: red;">
                                        {{ error.desError }}
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade" id="modalReincoporar" tabindex="-1" role="dialog"
                                aria-labelledby="myModalLabel">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <form>
                                            <div class="modal-header">
                                                <button type="button" class="close" data-dismiss="modal"
                                                    aria-label="Close"><span aria-hidden="true">X</span></button>
                                                <h4 class="fuente modal-title m-t-10" id="myModalLabel">{{ texto }}</h4>
                                            </div>
                                            <div class="fuente modal-body">
                                                Se reincoporará al ex-trabajador: {{ extrab.nombres }} {{ extrab.apePaterno
                                                }} {{ extrab.apeMaterno }}
                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="fuente btn btn-primary fs-13"
                                                    @click="merge()" data-dismiss="modal">
                                                    Agregar</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade" id="modalPensionar" tabindex="-1" role="dialog"
                                aria-labelledby="myModalLabel">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <form>
                                            <div class="modal-header">
                                                <button type="button" class="close" data-dismiss="modal"
                                                    aria-label="Close"><span aria-hidden="true">X</span></button>
                                                <h4 class="fuente modal-title m-t-10" id="myModalLabel">Pensionar
                                                    Ex-Trabajador
                                                </h4>
                                            </div>
                                            <div class="fuente modal-body">
                                                Se pensionará al ex-trabajador: {{ extrab.nombres }} {{ extrab.apePaterno}} 
                                                {{ extrab.apeMaterno }}<br />
                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="fuente btn btn-danger fs-13"
                                                    @click="merge()" data-dismiss="modal">Pensionar
                                                    Ex-Trabajador</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import 'datatables.net'
import 'datatables.net-bs'
import axios from 'axios'
import $ from 'jquery'
import { apiURL, apiLOGIN } from '@/store/state'
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
//import App from '../App.vue';
import App from '@/components/App.vue';
import moment from 'moment';

export default {
    name: 'Tables',
    data() {
        return {
            texto: '',
            error: {
                desError: ''
            },
            extrabs: [],
            extrab: {
                idTrabajador: '0',
                nombres: '',
                apePaterno: '',
                apeMaterno: '',
                dni: '',
                cargo: '',
                correo: '',
                sigla: '',
                fecha_nac: new Date(),
                idAppXUsu: '0',
                idUsuario: '0',
                nomUsuario: '',
                flagActivo: '1',
                usuario: this.$session.get('user')
            },
            tiempoActual: null,
            tiempoTokenExp: null
        }
    },
    mounted() {
        //this.tiempoActual = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });        
        //this.tiempoTokenExp = localStorage.getItem('TokenExpirationTime') 
        this.tiempoActual = moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a"); 
        this.tiempoTokenExp = moment(localStorage.getItem('TokenExpirationTime'), "D/M/YYYY, h:mm:ss a");
        
        if (!this.$session.exists('token')) {
            App.methods.logout.call(this);
            return;
        }

        if (this.tiempoActual < this.tiempoTokenExp) {
            // Realizar la validación con la API
            axios.defaults.headers.common['Authorization'] = this.$session.get('token')
            axios.get(`${apiLOGIN}/operaciones/app/GESU/operaciones`)
                .then(response => {
                    if (response.data.codError === 1 || response.data.desError === 'ok') {
                        this.carga()
                    } else {
                        this.alertaError();
                    }
                })
                .catch(error => {
                    if (error.response && error.response.status === 401) {
                        // Manejar el caso de error de autorización
                        //this.$router.go(-1);
                        this.alertaError401();
                    } else if (error.response && error.response.status === 403) {
                        //this.$router.go(-1);
                        this.alertaError();
                    } else if (error.response && error.response.status === 500) {
                        //this.$router.go(-1); 
                        this.alertaError500();
                    } else {
                        //this.$router.go(-1);
                        this.alertaError401();
                    }
                });

        } else {
            this.alertaError401();
        }
    },
    methods: {
        carga() {
            // Destruir la instancia DataTable si ya existe
            const dataTableInstance = $('#tablaDetalle').DataTable();
            if (dataTableInstance) {
                dataTableInstance.destroy();
            }

            axios.defaults.headers.common['Authorization'] = this.$session.get('token')
            axios.get(
                //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/usuarios/*'
                `${apiURL}/usuarios/extrabajadores/*`
            ).then(response => {
                this.extrabs = response.data
                //console.log('extrabs', this.extrabs)

                this.$nextTick(() => {
                    $('#tablaDetalle').DataTable({
                        stateSave: true, // Guarda el estado y la paginación de la tabla
                        'stateSaveParams': function (settings, data) {
                            data.length = 25; // Establece la longitud de la página
                        },
                        //lengthMenu: [10, 25, 50, 100], // Definir las opciones de registros por página
                        pageLength: 25, // Establecer el número de registros por página al iniciar
                        'oLanguage': {
                            'sSearch': 'Buscar',
                            'sInfo': 'Mostrando _START_ al _END_ de _TOTAL_ registros',
                            'sEmptyTable': 'Sin Data',
                            'sZeroRecords': 'No se encontraron coincidencias',
                            'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
                            'sLengthMenu': '_MENU_ Registros por página',
                            'sInfoEmpty': 'Mostrando 0 al 0 de 0 registros',
                            'oPaginate': {
                                'sPrevious': 'Anterior',
                                'sNext': 'Siguiente'
                            }
                        }
                    })
                })
            })
                .catch(error => {
                    if (error.response.status === 401) {
                        App.methods.logout.call(this);
                    }
                })

        },
        verReincorporar: function (item) {
            //this.limpiar()
            //this.extrab = { ...item }
            this.extrab = this.convertirJefatura({ ...item })
            this.extrab.flagActivo = '1'
            this.texto = 'REINCOPORAR EX-TRABAJADOR'
            this.error.desError = ''
            //console.log('------', this.extrab)
        },
        verPensionar: function (item) {
            //this.trab = { ...item }
            this.extrab = this.convertirJefatura({ ...item })
            this.extrab.flagActivo = '1'
            this.extrab.cargo = 'PENSIONISTA'
            // Verificar si this.extrab.jefatura es '1' antes de asignar 'null'
            if (this.extrab.jefatura == '1') {
                this.extrab.jefatura = 'null';
            }
            this.error.desError = ''
            //console.log('this.extrab', this.extrab)                  
        },
        merge: function () {
            if (moment(new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' }), "D/M/YYYY, h:mm:ss a") < this.tiempoTokenExp) {
                axios.post(
                    //'https://tomcat.sedetc.gob.pe/cas-services-0.0.2/operaciones/trab/add',
                    `${apiURL}/operaciones/trab/add`,
                    {
                        'idTrabajador': this.extrab.idTrabajador,
                        'nombres': this.extrab.nombres,
                        'apePaterno': this.extrab.apePaterno,
                        'apeMaterno': this.extrab.apeMaterno,
                        'dni': this.extrab.dni,
                        'cargo': this.extrab.cargo,
                        'anexo': this.extrab.anexo,
                        'fecNacimiento': this.extrab.fecNacimiento,
                        'correo': this.extrab.correo,
                        'celular': this.extrab.celular,
                        'jefatura': this.extrab.jefatura,
                        'sigla': this.extrab.sigla,
                        'flagActivo': this.extrab.flagActivo,
                        'usuario': this.$session.get('user')
                    }
                ).then(response => {
                    this.error = response.data
                    this.carga();
                })
                    .catch(error => {
                        if (error.response.status === 401) {
                            App.methods.logout.call(this);
                        }
                    })

            } else {
                this.alertaError401();
            }
        },
        convertirJefatura(extrab) {
            if (extrab.jefatura === 'SI') {
                extrab.jefatura = '1';
            } else if (extrab.jefatura === 'NO') {
                extrab.jefatura = null;
            } else {
                extrab.jefatura = extrab.jefatura;
            }
            // Puedes agregar más transformaciones según tus necesidades
            return extrab;
        },
        alertaError() {
            Swal.fire({
                icon: 'error',
                title: 'Usuario No Autorizado',
                text: 'No tienes permisos para acceder.',
                timer: 3000, // Duración en milisegundos
                timerProgressBar: true,
                showConfirmButton: false
            }).then(() => {
                // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.
                this.$router.push('/login');
            });
        },
        alertaError401() {
            Swal.fire({
                icon: 'error',
                title: 'La sesión ha expirado',
                //text: 'Vuelve a iniciar sesión.',
                footer: '<a href="#">Vuelve a iniciar sesión.</a>',
                timer: 4000, // Duración en milisegundos
                timerProgressBar: true,
                showConfirmButton: false
            }).then(() => {
                //this.$session.destroy()
                //this.$router.push('/login')
                App.methods.logout.call(this); ///Cierra la sesión                 
            });
        },
        alertaError500() {
            Swal.fire({
                icon: 'error',
                title: 'Error interno del servidor',
                text: 'Ocurrió un error. Por favor, inténtalo de nuevo más tarde..',
                timer: 5000, // Duración en milisegundos
                timerProgressBar: true,
                showConfirmButton: false
            }).then(() => {
                // Se redirecionará a la vista anterior cuando se cierre el cuadro de diálogo.
                this.$router.push('/login');
            });
        },
    },

}
</script>

<style></style>


// WEBPACK FOOTER //
// ExTrabajadores.vue?5cf1b6ce